import { useEffect, useRef, useState } from "react";
import { ShieldCheck, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { api, errMsg, setStepUpHandler } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { btnPrimary, inputCls } from "./ui";

export default function StepUpDialog() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const pending = useRef(null);
  const useCode = !!user?.mfa_enabled;

  useEffect(() => {
    setStepUpHandler(() => new Promise((resolve) => {
      pending.current = resolve;
      setValue(""); setErr(""); setOpen(true);
    }));
    return () => setStepUpHandler(null);
  }, []);

  const finish = (ok) => { setOpen(false); pending.current?.(ok); pending.current = null; };
  const submit = async (e) => {
    e.preventDefault(); setErr(""); setBusy(true);
    try {
      await api.post("/auth/step-up", useCode ? { code: value.trim() } : { password: value });
      finish(true);
    } catch (e2) { setErr(errMsg(e2)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && finish(false)}>
      <DialogContent data-testid="step-up-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><ShieldCheck className="h-5 w-5 text-bo-green" />Confirmar identidade</DialogTitle>
          <DialogDescription>Esta é uma ação sensível. {useCode ? "Introduza o código atual da aplicação autenticadora ou um código de recuperação." : "Introduza a sua palavra-passe."} A confirmação é válida durante 10 minutos.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="flex flex-col gap-3">
          <input autoFocus required type={useCode ? "text" : "password"} maxLength={useCode ? 20 : 128}
            autoComplete={useCode ? "one-time-code" : "current-password"} value={value} onChange={(e) => setValue(e.target.value)}
            className={`${inputCls} ${useCode ? "text-center text-lg tracking-[0.3em]" : ""}`} data-testid="step-up-input" />
          {err && <p className="rounded-xl bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="step-up-error">{err}</p>}
          <button disabled={busy || !value} className={btnPrimary} data-testid="step-up-submit-btn">{busy && <Loader2 className="h-4 w-4 animate-spin" />}Confirmar</button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
